export const environment = {
  production: true,
  baseUrl: window.location.protocol + '//' + window.location.hostname,

  authApiUrl: '/auth',
  commonApiUrl: '/common-service',
  fileApiUrl: '/file-service',
  adminUrl: '/administration-service',
  lisApiUrl: '/lis-service',
  risApiUrl: '/ris-service',
  ipdApiUrl: '/ipd-service',
  billingApiUrl: '/billing-service',
  prescriptionApiUrl: '/prescription-service',
  phrApiUrl: '/pharmacy-service',
  emergencyApiUrl: '/emergency-service',
  opdApiUrl: '/opd-service',
  patientPortalApiUrl: '/patientportal-service',
  medicalBoardAppUrl: '/medical-board-service',
  doctorHandoverApiUrl: '/doctor-handover-service',
  daycareApiUrl: '/daycare-service',
  dischargeApiUrl: '/discharge-service',
  refferalApiUrl: '/refferal-service',
  storeApiUrl: '/store-service',
  emrApiUrl: '/emr-service',
  hrmApiUrl: '/hrm-service',
  accountsApiUrl: '/accounting-service',
  cafeApiUrl: '/cafeteria-service',
  reagentApiUrl: '/reagent-service',
  dietApiUrl: '/diet-service',
  reportApiUrl: '/report-service',
  bloodBankApiUrl: '/blood-bank-service',
  otApiUrl: '/ot-service',

  // Misc
  reportPath: '',
  pClient: 'DEFAULT',
  pLayout: 1,
  reagentStore: 47,
  traigeUrl: 'https://azure-frontend-triage.eatlbd.com'
};
